import request from 'utils/request';
import config from 'config/Config';

export default class {
  // 获取民族列表
  static getNationList(params) {
    return request({
      url: `basic/nation/list`,
      host: config.HOST_MALL,
      params
    });
  }

  // 获取银行总行列表
  static getHeadBankList() {
    return request({
      url: `basic/bank/query/enable/headBank`,
      host: config.HOST_MALL
    });
  }

  // 获取指定卡号的用户姓名
  static getMemberName(params) {
    return request({
      url: `user/info/getMemberName`,
      host: config.HOST_MALL,
      ignoreErr: true,
      params
    });
  }

  // 获取指定卡号的用户信息
  static getMemberInfo(params) {
    return request({
      url: `user/info/getMemberInfo`,
      host: config.HOST_MALL,
      ignoreErr: true,
      params
    });
  }

  // 获取本人注册时所填写的健康顾问
  static getHealthyUser() {
    return request({
      url: `user/info/getUserInfo`,
      host: config.HOST_MALL,
      ignoreErr: true
    });
  }

  // 申请开卡
  static apply(params, checkSaleNum) {
    const url = checkSaleNum
      ? `user/register/queryCardType?checkSaleNum=${checkSaleNum}`
      : `user/register/queryCardType`;
    return request({
      url,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params,
      ignoreErr: true
    });
  }
  // 民族加校验
  static nationValidate(params) {
    return request({
      url: `valetOpenCard/queryCardTypeWithNation?healthConsultantNum=${params.healthConsultantNum}&nation=${params.nation}`,
      host: config.HOST_STORE,
      method: 'post_json'
    });
  }

  // 提交累计信息
  static accumulateUserInfo(params) {
    const status = 1;
    return request({
      url: `user/info/accumulateUserInfo/${status}`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  // DZC是否带出销售顾问
  static queryDZCMemberSaleNumber(healthy) {
    return request({
      url: `user/register/queryDZCMemberSaleNumber?healthConsultNum=` + healthy,
      host: config.HOST_MALL,
      method: 'get'
    });
  }

  // 校验DZC销售顾问
  static checkSaleConsultNum(params) {
    return request({
      url: `user/register/matchDZCMemberSaleNumber`,
      host: config.HOST_MALL,
      method: 'get',
      params
    });
  }

  /**
   * 获取是否显示完善资料
   */
  static getUserShouldSupply() {
    return request({
      url: 'user/info/getUserShouldSupply',
      host: config.HOST_MALL,
      method: 'get'
    });
  }

  /**
   * 获取推荐人安置情况
   */
  static loadAreaResettleData(healthy) {
    return request({
      url: `user/register/getSaleMembers?cardCode=${healthy}`,
      host: config.HOST_MALL,
      method: 'get'
    });
  }

  /**
   * 创建订单
   */
  static addOrder(url, params) {
    return request({
      url,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Register/MemCardMsg/MemCardMsgServ.js